import moment from 'moment';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import EditSvg from 'images/v5/icons/edit-02.svg';
import CollectionsSvg from 'images/v5/icons/menu/collections.svg';
import PlanningSvg from 'images/v5/icons/menu/planning.svg';
import ProductionManagerSvg from 'images/v5/icons/menu/production-manager.svg';
import ShipmentsSvg from 'images/v5/icons/menu/shipments.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Dropdown from 'layout/atoms//Dropdown/Dropdown';
import ExpandableLinkList from 'layout/atoms//ExpandableLinkList';
import StatusBadge from 'layout/atoms//StatusBadge';
import Button from 'layout/atoms/Button/Button';
import { Cell, Row } from 'layout/atoms/TableGrid';
import { openModal, openSidebar } from 'store/layoutSlice';
import { selectDelayedOrderIds, selectPlannedOrderIds } from 'store/ordersSlice';
import styles from './OrdersListItem.module.scss';
function OrdersListItem({ order }) {
    var _a, _b, _c, _d;
    const { t } = useTranslation(['common', 'orders']);
    const dispatch = useDispatch();
    const delayedOrderIds = useSelector(selectDelayedOrderIds);
    const plannedOrderIds = useSelector(selectPlannedOrderIds);
    const links = order.models.edges.map((model) => {
        return {
            id: model.node.id,
            label: model.node.modelSpecificationNode.itemCode,
            onClick: () => {
                dispatch(openSidebar({
                    name: 'specificationPreview',
                    id: model.node.modelSpecificationNode.id,
                }));
            },
        };
    });
    const suppliers = order.orderSuppliers.edges.map((supplier) => {
        return {
            id: supplier.node.supplier.id,
            label: supplier.node.supplier.shortName,
            // eslint-disable-next-line no-console
            onClick: () => console.log('Show supplier details in sidebar/modal?'),
        };
    });
    const STATUS_COLORS = {
        DRAFT: 'neutral',
        APPROVED: 'info',
        CANCELLED: 'negative',
        DONE: 'positive',
    };
    const handleRemove = useCallback(() => {
        dispatch(openModal({ name: 'removeOrder', data: { id: order.id, orderId: order.orderId } }));
    }, [dispatch, order.id, order.orderId]);
    const isDelayed = delayedOrderIds.includes(order.id);
    const isPlanned = plannedOrderIds.includes(order.id);
    const firstOrderModelId = (_c = (_b = (_a = order.models.edges) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.node) === null || _c === void 0 ? void 0 : _c.id;
    const orderLink = !order.orderDeliveryDate && firstOrderModelId
        ? `/orders/creator/${order.id}/production-volume/${firstOrderModelId}`
        : `/orders/${order.id}`;
    const requiresCompletion = !order.orderDeliveryDate;
    return (React.createElement(Row, null,
        React.createElement(Cell, { align: "left" },
            React.createElement(Link, { to: orderLink, className: styles.link }, order.orderId)),
        React.createElement(Cell, { align: "left" }, ((_d = order === null || order === void 0 ? void 0 : order.season) === null || _d === void 0 ? void 0 : _d.name) || '-'),
        React.createElement(Cell, { align: "left" },
            React.createElement(ExpandableLinkList, { links: links, maxWidth: "300px", title: t('orders:models') })),
        React.createElement(Cell, { align: "left" },
            React.createElement(ExpandableLinkList, { links: suppliers, maxWidth: "300px", title: t('orders:suppliers') })),
        React.createElement(Cell, { align: "left" }, moment(order.createdDate).format('DD.MM.YYYY')),
        React.createElement(Cell, { align: "left" }, moment(order.modifiedDate).format('DD.MM.YYYY')),
        React.createElement(Cell, { align: "left" },
            React.createElement(StatusBadge, { noIcon: true, size: "s", theme: "fill", color: "neutral" }, order.modifiedDate ? t('common:yes') : t('common:no'))),
        React.createElement(Cell, { align: "left" },
            React.createElement("div", { className: styles.statusCell },
                React.createElement(StatusBadge, { noIcon: true, size: "s", theme: "fill", color: STATUS_COLORS[order.status] }, t(`orders:status.${order.status}`)),
                (isDelayed || isPlanned) && (React.createElement("div", { className: styles.statusMarkers },
                    isDelayed && React.createElement("span", { className: `${styles.statusDot} ${styles.statusDotDelayed}` }),
                    isPlanned && React.createElement("span", { className: `${styles.statusDot} ${styles.statusDotPlanned}` }))))),
        React.createElement(Cell, null,
            React.createElement(Dropdown, null, requiresCompletion ? (React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), to: orderLink }, t('orders:complete_order_data'))) : (React.createElement(React.Fragment, null,
                React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(CollectionsSvg, null), to: `/orders/${order.id}/collections` }, t('orders:collections')),
                React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(ProductionManagerSvg, null), to: `/orders/${order.id}/production-manager` }, t('orders:production-manager')),
                React.createElement("hr", null),
                React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(PlanningSvg, null), to: `/orders/${order.id}/planning` }, t('orders:planning')),
                React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(ShipmentsSvg, null), disabled: true }, t('orders:shipments')),
                React.createElement("hr", null),
                React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: handleRemove }, t('delete'))))))));
}
export default OrdersListItem;
